import { groupBy } from 'lodash';
import { Tier } from 'types/subscription.types';
import { GroupedTiers } from './types';

export const CURRENCY_SIGN = {
  usd: '$',
  eur: '€',
  gbp: '£',
};

export const processTiers = (tiers: Tier[]) => {
  const group: GroupedTiers[] = [];
  tiers.forEach((tier: Tier) => {
    const groupedBy = groupBy(tier.pricingPlans, 'interval');
    group.push({ tier, ...groupedBy });
  });

  return group;
};

export const formatOption = (currency: string) => ({
  value: currency,
  title: `${CURRENCY_SIGN[currency || '']}${currency?.toUpperCase()}`,
});

export const processCurrencyList = (currencyList: string[]) => {
  return currencyList.map((item: string) => {
    return formatOption(item);
  });
};

export const DEFAULT_OPTION = formatOption('usd');
